export const customerAccountClaimsFilterState = () => ({
  page: 1,
  perPage: 10
});
